import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdminWorkspaceSubTypeV2ListResponse,
  AdminWorkspaceSubTypeV2Schema,
} from '../types';
import { ADMIN_SUBMISSIONS_URL, ADMIN_WORKSPACE_TYPE_URL } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class SubmissionAdminService {
  private readonly _http = inject(HttpClient);

  /**
   * List workspace sub types (admin version) with advanced filtering and search capabilities.
   * @param queryParams - HttpParams generated by wcgTableUtils.generateTableQueryParams() which includes properly encoded filters
   * @returns An Observable of AdminWorkspaceSubTypeV2ListResponse containing the filtered sub types data.
   */
  listWorkspaceSubTypes(
    queryParams: HttpParams,
  ): Observable<AdminWorkspaceSubTypeV2ListResponse> {
    // HttpParams already has everything prepared by wcgTableUtils including:
    // - page, page_size
    // - query (search)
    // - filters (base64 encoded)
    // - sort_by_field, sort_by_order
    // - timezone, timezone_identifier
    // - grid_view flag

    return this._http.get<AdminWorkspaceSubTypeV2ListResponse>(
      `${ADMIN_SUBMISSIONS_URL}/sub_type/`,
      { params: queryParams },
    );
  }

  /**
   * Get a single workspace type by ID
   * @param workspaceTypeId - The workspace type ID
   * @param entityType - The entity type (optional)
   * @returns An Observable of AdminWorkspaceSubTypeV2Schema containing the workspace type data
   */
  getWorkspaceTypeById(
    workspaceTypeId: string,
    entityType?: string,
  ): Observable<AdminWorkspaceSubTypeV2Schema> {
    let params = new HttpParams();

    if (entityType) {
      params = params.set('entity_type', entityType);
    }

    return this._http.get<AdminWorkspaceSubTypeV2Schema>(
      `${ADMIN_WORKSPACE_TYPE_URL}/${workspaceTypeId}/`,
      { params },
    );
  }
}
